/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  GetSegment,
  ThemeData,
  UtilityReducer,
  UserCardBase,
  ValidateLoginToken,
  ApplyThemeStyles,
  encodeBase64,
  ProductContentData,
  DealCouponData,
  SectionContentMasterData,
  DealData,
  UnlocksectionactivityData,
  SectionMasterData,
  ClientPlatformCode,
  UserIdAndStatusData,
  trackEvent,
  DefaultCardName,
} from "../../Utility/Utility";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import { onSaveUnlockContId } from "../../Store/Slices/utilityReducer";
import {
  onGetUserCardBaseHead,
  onPostUserCardBase,
  onPostUserCardBaseReset,
} from "../../Store/Slices/userCardBaseSlice";
import OfferLoader from "../../Utility/Loader/offerLoader";
import { onLandingHome, onLandingHomePostLogin } from "../../Store/Slices/homePageLandingSlice";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";

const WelcomeBonus = () => {
  const login = sessionStorage.getItem("login");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const translation = getTranslation();
  const { clientCode, platformCode } = ClientPlatformCode();
  const { userId, userStatus } = UserIdAndStatusData();
  const defaultCardName = DefaultCardName();
  const { productContentData } = ProductContentData();
  const { dealData } = DealData();
  const { dealCouponData } = DealCouponData();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = parseInt(queryParams.get("stid"));
  const { sctionContentdata } = SectionContentMasterData();
  const { sectionMasterData } = SectionMasterData(login);
  const sectionContent = sctionContentdata?.filter(
    (findData) => findData?.sectionMasterId === id
  );
  const card = UtilityReducer();
  const token = ValidateLoginToken();
  const unlockList = UnlocksectionactivityData()
  const unlock = unlockList?.unlockData;
  const usercardBase = UserCardBase();
  const segmentData = GetSegment();
  const segments = segmentData?.data?.[0]?.mappedSegment;
  const [url, setUrl] = useState(null);
  const currentSegmentCard = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  )?.subIdentifier;
  const currentSegmentExpiry = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  )?.validTill;
  const currentSegmentMapped = segments?.find(
    (filterData) => filterData?.segmentId === card?.segmentId
  );
  const currentCardData = card?.creditCards?.find(
    (filterData) => filterData?.identifier === currentSegmentCard
  );
  const identifier = useSelector(
    (state) => state?.validateLoginTokenSliceReducer?.data
  );
  const unlockAPIData = useSelector((state) => state?.unlockSectionReducer);
  const backBtnRef = useRef(false);
  const homePageSlice = useSelector((state) => state.homePageSliceReducer);
  const [filterProducts, setFilterProducts] = useState([]);
  useEffect(() => {
    if (productContentData && productContentData.length <= 0 && dealData && dealData.length <= 0 && dealCouponData && dealCouponData.length <= 0 && sctionContentdata && sctionContentdata.length <= 0) {
      dispatch(onLandingHome());
      let cardCodeValue = [
        ...new Set(
          token?.otherListAttribute?.[0]?.valueDetails
            ?.filter(card => card.status === "1" || card.status === "2")
            ?.map(card => card.CardTypeName?.toLowerCase())
            .filter(Boolean)
        )
      ] || [];
      dispatch(onLandingHomePostLogin({ memberIdentifier: token?.memberIdentifier, cardCode: encodeURIComponent(cardCodeValue.join(", ")) }))
    }

  }, [productContentData, dealData, dealCouponData, sctionContentdata]);

  useEffect(() => {
    if (backBtnRef?.current === true) return;
    const handlePageShow = (event) => {
      if (event.persisted) {
        // Page restored from bfcache
        fetchAPIs();
        setLoading(true);
      }
    };
    fetchAPIs();
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [location]);

  useEffect(() => {
    if (loading && unlockAPIData?.get_status_code) {
      setLoading(false);
    }
  }, [unlockAPIData]);

  useEffect(() => {
    if (loading && homePageSlice?.post_login_success && !homePageSlice?.isPostLoginLoading) {
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }, [homePageSlice?.post_login_success, homePageSlice?.isPostLoginLoading]);

  useEffect(() => {
    if (homePageSlice?.post_login_success && !homePageSlice?.isPostLoginLoading) {
      let claimData = homePageSlice?.homePageData?.unlockSectionActivities || [];
      checkClaimLimit(claimData);
      setProducts();
    }
  }, [homePageSlice]);

  useEffect(() => {
    setProducts();
  }, []);

  const fetchAPIs = () => {
    dispatch(onGetUserCardBaseHead({ customerUcicId: token?.memberIdentifier }));

    let cardCodeValue = [
      ...new Set(
        token?.otherListAttribute?.[0]?.valueDetails
          ?.filter(card => card.status === "1" || card.status === "2")
          ?.map(card => card.CardTypeName?.toLowerCase())
          .filter(Boolean)
      )
    ] || [];
    dispatch(onLandingHomePostLogin({ memberIdentifier: token?.memberIdentifier, cardCode: encodeURIComponent(cardCodeValue.join(", ")) }))
  }

  const isClaimed = (linkedMasterId, card) => {
    if (!unlock?.length) return false;
    const sectionIdSet = new Set(
      sectionContent?.map((s) => s.sectionMasterId)
    );

    const idKey =
      card?.productType === "Gift Cards" || card?.productType === "Products"
        ? "linkedMasterId"
        : "coupounId";

    return unlock.some(
      (item) =>
        item[idKey] === linkedMasterId &&
        item.status === false &&
        sectionIdSet.has(item.sectionId)
    );
  };

  const setProducts = () => {
    if ((!sectionContent || !productContentData || !dealCouponData) && filterProducts.length > 0) {
      setFilterProducts([]);
      return;
    }
    const productOrGiftCardContent = sectionContent.filter(
      (item) =>
        item?.contentSourceType === "Products" ||
        item?.contentSourceType === "Gift Cards"
    );

    const filteredProductsData = productOrGiftCardContent
      .map((item) =>
        productContentData.find(
          (product) => product.productId === item.linkedMasterId
        )
      )
      .filter(Boolean);
    const filteredDeals = dealCouponData.filter((deal) =>
      sectionContent?.some((item) => item.linkedMasterId === deal.id)
    );

    const filterData = [...filteredProductsData, ...filteredDeals].map((item) => {
      if (isClaimed(item?.productId || item?.id, item)) {
        return { ...item, isClaimed: true }
      }
      return { ...item, isClaimed: false }
    });
    setFilterProducts(filterData);
  }

   const getTextFromHtml = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.body.textContent || '';
    };
  const handleClick = (product, giftcard, data, index, imageUrl) => {
    const deal = dealData?.find((findData) => findData?.id === data?.dealId);
    const sectionContentId = sectionContent?.find(
      (findData) => findData?.linkedMasterId === data?.productId
    )?.id;
    trackEvent("welcome_offer_card", {
      page_type: "welcome_bonus_page",
      section_title: getTextFromHtml(card.text),
      image_url: imageUrl,
      item_position: index + 1,
      brand_name: deal?.name || "NA",
      segment_id: data?.segmentId || "NA",
      welcome_offer_name: data?.name || "NA",
      offer_name: data?.title || "NA",
      client_code: clientCode,
      platform_code: platformCode,
      user_id: userId,
      user_status: userStatus,
      card_name: defaultCardName
    });

    setLoading(true);
    dispatch(onSaveUnlockContId({ sectionContentId }));

    if (product || giftcard) {
      const payLoad = {
        enabled: true,
        createdBy: 10,
        cardFirstFourDigitNumber: currentCardData?.CardNoFirst6Digit,
        cardLastFourDigitNumber: currentCardData?.CardNoLast4Digit,
        cardName: currentCardData?.CardTypeName,
        customerUcicId: identifier.memberIdentifier,
        offerName: card?.text,
        name: identifier?.memberProfile?.firstName,
        email: identifier?.memberProfile?.emailId,
        phoneNumber: identifier?.memberProfile?.mobileNumber,
        cardSubIdentifier: currentCardData?.identifier,
        cardImage: currentCardData?.backgroundcolor,
        productId: data?.productId,
        sectionMasterId: card?.sectionId,
        offerDetail: {
          offer_activation_date: currentSegmentMapped?.validFrom
            ? new Date(
              new Date(currentSegmentMapped.validFrom)
                .toISOString()
                .split("T")[0] + "T00:00:00.000Z"
            ).toISOString()
            : null,

          offer_expiry_date: currentSegmentMapped?.validTill
            ? new Date(
              new Date(currentSegmentMapped.validTill)
                .toISOString()
                .split("T")[0] + "T00:00:00.000Z"
            ).toISOString()
            : null,
          segment_id: currentSegmentMapped?.segmentId || null,
          segment_name: currentSegmentMapped?.segmentName || null,
        }
      };

      dispatch(onPostUserCardBase(payLoad));
      const base64Value = encodeBase64(`giftcardnew.aspx?vid=${data?.productId}&sectionid=${card?.sectionId}&sectioncontentid=${sectionContentId}`)
      const productUrl = process.env.REACT_APP_SHOPSTACC_URL + `/GiftCards/` + base64Value;

      setUrl(productUrl);

    } else {
      navigate("/welcome-voucher", { state: { deal, coupons: data } });
    }
  };

  const themeData = ThemeData();

  useEffect(() => {
    ApplyThemeStyles(themeData);
  }, [themeData]);

  const handlereDirect = () => {
    setLoading(true);
    window.open(url, "_self");
  };

  useEffect(() => {
    if (usercardBase.post_status_code === "200") {
      handlereDirect();
      dispatch(onPostUserCardBaseReset());
      dispatch(onGetUserCardBaseHead({ customerUcicId: token.memberIdentifier }));
    }
  }, [usercardBase]);

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const checkClaimLimit = (unlockData) => {
    const sectionData = sectionMasterData?.find((item) => item.id === id);
    const claimData = unlockData?.filter((item) => item.sectionId === id)
    if (claimData && claimData.length >= sectionData?.claimLimit) {
      navigate("/");
      sessionStorage.removeItem("postLoginSuccesCount");
    }
  }

  if (
    loading ||
    usercardBase.isgetLoading ||
    usercardBase.isPostLoading ||
    homePageSlice?.isPostLoginLoading ||
    !sectionContent
  ) {
    return <OfferLoader />;
  }
  return (
    <>
      <ScrollToTop />
      <div className="claim-container">
        <CustomBackHeader
          title={translation?.claimYourBenefits}
          backBtnRef={backBtnRef}
        />


        <div className="px-4 py-4">
          <div dangerouslySetInnerHTML={{ __html: card.text }}></div>
          {formatDate(currentSegmentExpiry) && <div className="redeem-container mt-2">
            <h2>{translation.redeemOfferMessage} {formatDate(currentSegmentExpiry)}</h2>
          </div>}
          <div className="card-grid mt-4">
            {filterProducts?.map((card, index) => {
              const isProductType =
                card?.productType === "Gift Cards" ||
                card?.productType === "Products";
              const isDealType = !card?.productId && card?.dealId;
              const isDisabled = card?.isClaimed;

              const brandName = dealData?.find(x => x?.id === card?.dealId)?.name || "";
              card.name = card?.name ? card?.name : brandName ? brandName : "";
              const imageUrl = isProductType
                        ? card.image : `${process.env.REACT_APP_CLIENT_IMAGE_URL}${dealData?.find(
                          (deal) => deal.id === card?.dealId
                        )?.brandOfferImg}`;
              return (
                <div
                  key={index}
                  className={`gift-card ${isDisabled ? "disabled" : ""}`}
                >
                  {isProductType && (
                    <div className="leading-tight gift-head">
                      <span className=" line-clamp-1">
                        {card?.name}
                      </span>
                    </div>
                  )
                  }

                  <img
                    onClick={() =>
                      handleClick(isProductType, isProductType, card, index, imageUrl)
                    }
                    src={imageUrl}
                    className={`${card?.productType === "Products"
                      ? "object-con"
                      : "object-cov"
                      } ${isDisabled ? "greyed-out" : ""}`}
                    alt={card?.name}
                    data-url={card?.productUrl}
                    title={card?.name}
                  />

                  {isDealType && (
                    <div className="pl-2 pt-2">
                      <div
                        className="titile-head  line-clamp-1"
                        onClick={() =>
                          handleClick(isProductType, isProductType, card, index, imageUrl)
                        }
                        title={card?.name}
                        data-url={card?.productUrl}
                      >{card?.name}
                      </div>
                      <div
                        className="title-claim-welcome  line-clamp-1"
                        onClick={() =>
                          handleClick(isProductType, isProductType, card, index, imageUrl)
                        }
                      >{card?.title}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div >
    </>
  );
};

export default WelcomeBonus;
